import customFetch from "../helpers/customFetch";
import { API_URL, getConfigExactian } from "../helpers/helpers";

export const getSettingMenuService = async () => {
    try {
        const configs = getConfigExactian('GET');
        const response = await customFetch(`${API_URL}parameters/menu`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const getSettingService = async (query) => {
    try {
        const configs = getConfigExactian('GET');
        const response = await customFetch(`${API_URL}parameters${query ? query : ''}`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const setSettingService = async (setting) => {
    try {
        const configs = getConfigExactian('PUT', setting);
        const response = await customFetch(`${API_URL}parameters`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const getOpenningsListService = async (query) => {
    try {
        const configs = getConfigExactian('GET');
        const response = await customFetch(`${API_URL}openings?${query ? query : ''}`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const changeConfigToOpenningService = async (setting) => {
    try {
        const configs = getConfigExactian('PUT', setting);
        const response = await customFetch(`${API_URL}openings`, configs);
        const resData = await response.json();
        if (!resData.success) {
            return {
                ok: false,
                data: resData
            }
        } else {
            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

//BUILDINGS
export const getListOfBuildingstService = async (query) => {
    try {
        const configs = getConfigExactian('GET');
        const response = await customFetch(`${API_URL}buildings?${query ? query : ''}`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const deleteBuildingService = async (id) => {
    try {
        const configs = getConfigExactian('DELETE');
        const response = await customFetch(`${API_URL}buildings/${id}`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const createBuildingService = async (building) => {
    try {
        const configs = getConfigExactian('POST', building);
        const response = await customFetch(`${API_URL}buildings`, configs);
        const resData = await response.json();
        if (!resData.success) {
            return {
                ok: false,
                data: resData
            }
        } else {
            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const editBuildingService = async (building) => {
    try {
        const configs = getConfigExactian('PUT', building);
        const response = await customFetch(`${API_URL}buildings`, configs);
        const resData = await response.json();
        if (!resData.success) {
            return {
                ok: false,
                data: resData
            }
        } else {
            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

//AREAS

export const getListOfAreasService = async (query) => {
    try {
        const configs = getConfigExactian('GET');
        const response = await customFetch(`${API_URL}areas?${query ? query : ''}`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const deleteAreasService = async (id) => {
    try {
        const configs = getConfigExactian('DELETE');
        const response = await customFetch(`${API_URL}areas/${id}`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const createAreaService = async (area) => {
    try {
        const configs = getConfigExactian('POST', area);
        const response = await customFetch(`${API_URL}areas`, configs);
        const resData = await response.json();
        if (!resData.success) {
            return {
                ok: false,
                data: resData
            }
        } else {
            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const editAreaService = async (area) => {
    try {
        const configs = getConfigExactian('PUT', area);
        const response = await customFetch(`${API_URL}areas`, configs);
        const resData = await response.json();
        if (!resData.success) {
            return {
                ok: false,
                data: resData
            }
        } else {
            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

//PEOPLE TO VISIT

export const getListOfPeopleToVisitService = async (query) => {
    try {
        const configs = getConfigExactian('GET');
        const response = await customFetch(`${API_URL}peopleToVisit?${query ? query : ''}`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const deletePersonToVisitService = async (id) => {
    try {
        const configs = getConfigExactian('DELETE');
        const response = await customFetch(`${API_URL}peopleToVisit/${id}`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const createPersonToVisitService = async (sector) => {
    try {
        const configs = getConfigExactian('POST', sector);
        const response = await customFetch(`${API_URL}peopleToVisit`, configs);
        const resData = await response.json();
        if (!resData.success) {
            return {
                ok: false,
                data: resData
            }
        } else {
            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const editPersonToVisitService = async (person) => {
    try {
        const configs = getConfigExactian('PUT', person);
        const response = await customFetch(`${API_URL}peopleToVisit`, configs);
        const resData = await response.json();
        if (!resData.success) {
            return {
                ok: false,
                data: resData
            }
        } else {
            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}
//SECTORS

export const getListOfSectorsService = async (query) => {
    try {
        const configs = getConfigExactian('GET');
        const response = await customFetch(`${API_URL}sectors?${query ? query : ''}`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const deleteSectorService = async (id) => {
    try {
        const configs = getConfigExactian('DELETE');
        const response = await customFetch(`${API_URL}sectors/${id}`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const createSectorService = async (sector) => {
    try {
        const configs = getConfigExactian('POST', sector);
        const response = await customFetch(`${API_URL}sectors`, configs);
        const resData = await response.json();
        if (!resData.success) {
            return {
                ok: false,
                data: resData
            }
        } else {
            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const editSectorService = async (sector) => {
    try {
        const configs = getConfigExactian('PUT', sector);
        const response = await customFetch(`${API_URL}sectors`, configs);
        const resData = await response.json();
        if (!resData.success) {
            return {
                ok: false,
                data: resData
            }
        } else {
            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

//Equipment Or Tools

export const getEquipmentOrToolsTypesService = async (equipmentTypeId = null) => {
    try {
        const configs = getConfigExactian('GET');
        const response = await customFetch(`${API_URL}equipmentsType/${equipmentTypeId ? `?equipmentTypeId=${equipmentTypeId}` : ''}`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {
            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const createEquipmentOrToolsTypesService = async (type) => {
    try {
        const configs = getConfigExactian('POST', type);
        const response = await customFetch(`${API_URL}equipmentsType`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {
            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const editEquipmentOrToolsTypesService = async (type) => {
    try {
        const configs = getConfigExactian('PUT', type);
        const response = await customFetch(`${API_URL}equipmentsType`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {
            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const deleteEquipmentOrToolTypeService = async (equipmentTypeId = '') => {
    try {
        const configs = getConfigExactian('DELETE');
        const response = await customFetch(`${API_URL}equipmentsType/${equipmentTypeId}`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {
            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}